/* eslint-disable jsx-a11y/media-has-caption */
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, makeStyles, Theme, Tabs, Tab } from '@material-ui/core';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ReactQuill from 'react-quill';
import ReactPlayer from 'react-player';
import 'react-quill/dist/quill.snow.css';
import { useHistory, useLocation } from 'react-router-dom';

import { Button } from '../../../../../shared/components/Button';
import { Input } from '../../../../../shared/components/Form/Input';
import { PageContainer } from '../../../../../shared/components/PageContainer';
import { useSnackMessages } from '../../../../../shared/hooks/useSnackMessages';
import { api } from '../../../../../shared/services/apiClient';
import { UploadImage } from '../../../components/UploadImage';
import { ICustomData, IForm } from '../types';
import { schema } from './schema';

export function BlogEdit() {
  const useStyles = makeStyles((theme: Theme) => ({
    field: {
      borderRadius: '4px',
      height: '200px',
      [theme.breakpoints.down(524)]: {
        height: '230px',
      },
    },
  }));
  const classes = useStyles();

  const history = useHistory();
  const { state } = useLocation<{ blog: ICustomData }>();
  const { msgSuccess, msgError } = useSnackMessages();

  const [file, setFile] = useState<any>();
  const [loading, setLoading] = useState(false);

  // SE FOR VÍDEO OU IMAGEM
  const initialTab = state.blog.url ? 1 : 0; // 0 = imagem | 1 = vídeo
  const [mediaTab] = useState(initialTab);

  const [description, setDescription] = useState(state.blog.description || '');
  const [videoUrl, setVideoUrl] = useState(state.blog.url || '');

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...state.blog,
      videoUrl: state.blog.url || '',
    },
  });

  const handlePush = useCallback(() => {
    history.push('/blog');
  }, [history]);

  useEffect(() => {
    if (!state?.blog?.id) {
      handlePush();
    }
  }, [state?.blog?.id, handlePush]);

  const onSubmit = useCallback(
    async ({ title }: IForm) => {
      const currentFile = String(file);

      // ==== EDITAR COM NOVA IMAGEM ====
      if (
        (file && !state?.blog?.image) ||
        (file &&
          state?.blog?.image &&
          !currentFile.includes(state?.blog?.image))
      ) {
        try {
          const formDataFile = new FormData();
          formDataFile.append('blog', file);

          const response = await api.post('/admin/blog/image', formDataFile);

          if (!response.data) {
            return;
          }

          await api.put(`/admin/blog/${state?.blog?.id}`, {
            description,
            title,
            image: response.data?.fileName,
            old_image: state?.blog?.image,
          });

          setFile(undefined);
          msgSuccess('Post atualizado com sucesso!');
          history.push('/blog');
          return;
        } catch (err: any) {
          setLoading(false);
          msgError(err?.response?.data?.message);
          return;
        }
      }

      // ==== EDITAR SEM NOVA IMAGEM ====
      try {
        await api.put(`/admin/blog/${state?.blog?.id}`, {
          description,
          title,
        });

        msgSuccess('Post atualizado com sucesso!');
        history.push('/blog');
        return;
      } catch (err: any) {
        setLoading(false);
        msgError(err?.response?.data?.message);
      }
    },
    [
      msgSuccess,
      msgError,
      file,
      history,
      state?.blog?.id,
      state?.blog?.image,
      description,
    ]
  );

  return (
    <PageContainer component="form" onSubmit={handleSubmit(onSubmit)}>
      <Tabs
        value={mediaTab}
        indicatorColor="primary"
        textColor="primary"
        style={{ marginBottom: 20 }}
      >
        <Tab label="Imagem" disabled />
        <Tab label="Vídeo" disabled />
      </Tabs>

      <Box display="flex" flexDirection="column" mb={3} width="100%">
        {/* -------------------------------- */}
        {/* SE FOR IMAGEM */}
        {/* -------------------------------- */}
        {mediaTab === 0 && (
          <>
            <Box>
              A <strong>Imagem</strong> será <strong>redimensionada</strong>{' '}
              para até
              <strong>800×600</strong>. Prefira imagens{' '}
              <strong>horizontais</strong>.
            </Box>

            <UploadImage
              preview={state.blog.image_url}
              onFile={(value) => setFile(value)}
            />
            <Box mb={2} />
          </>
        )}

        {/* -------------------------------- */}
        {/* SE FOR VÍDEO */}
        {/* -------------------------------- */}
        {mediaTab === 1 && (
          <>
            <Box mb={2}>
              <Input
                name="videoUrl"
                label="Link do vídeo (YouTube)"
                control={control}
                variant="outlined"
                fullWidth
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
            </Box>

            {videoUrl && (
              <ReactPlayer url={videoUrl} width="100%" height={300} controls />
            )}
            <Box mb={2} />
          </>
        )}

        <Input
          name="title"
          control={control}
          error={errors}
          label="Título"
          variant="outlined"
          fullWidth
          disabled={isSubmitting}
          required
        />

        <Box mb={2} />

        <fieldset className={classes.field}>
          <legend style={{ marginBottom: '10px' }}>Descrição:</legend>

          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            style={{
              minHeight: '100px',
              marginLeft: '10px',
              marginRight: '10px',
              height: '100px',
            }}
          />
        </fieldset>
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isSubmitting || loading}
          size="large"
        >
          Salvar
        </Button>
      </Box>
    </PageContainer>
  );
}
